import { useIsFetching } from '@tanstack/react-query';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { Typography } from '@/shared/components/atoms/Typography';

import Loading from '~/images/shared/Loading.svg';

// TODO :Need a way to use translation here
const RQIsFetchingLoader = () => {
  const { t } = useTranslation('common');
  const isFetching = useIsFetching();
  return isFetching ? (
    <div className='fixed top-64 z-50 flex w-full items-center justify-center'>
      <Loading className='animate-spin ' />

      <Typography variant='caption' className='mx-1 text-text-secondary'>
        {t('updating')}
      </Typography>
    </div>
  ) : (
    <></>
  );
};
export default RQIsFetchingLoader;
